import * as constants from "./constants";

export const toggleQuickForm = () => {
  document.body.classList.add('quick-form');
  document.querySelectorAll('.panel').forEach(el => {
    el.classList.remove('fade');
    el.classList.add(constants.classes.activeClass);
  });
  constants.elements.btnNext.textContent = 'Make Payment';
};